export default __webpack_public_path__ + "static/media/sketch-league-tn.1f136dc4.png";